import { api } from '@/main'

const profile = {
  namespaced: true,  
  state: () => ({
    loaded: false,
    data: null,
    programs: null
  }),
  mutations: {
    startLoad(state) {
      state.data = null
      state.programs = null
      state.loaded = false
    },
    set(state, newData) {
      if (!!newData) {
        state.data = newData.profile
        state.programs = newData.programs
      } else {
        state.data = null
        state.programs = null
      }
      state.loaded = true
    }
  },
  actions: {
    async reload({ commit, state }) {
      let profile = await api.queries.selectRow('appl_gjo_cabinet2.get_user_info',{})
      if (profile === null) throw new Error('Вход невозможен. Профиль не найден.')
      let programs = await api.queries.select('APPL_GJO_CABINET2.GET_ACTIVE_PROGRAM_LIST',{},1000,0)
      commit('set', {profile, programs})
    }
  },
  getters: {
    fullName(state) {
      const d = state.data
      if (!d) return ''
      return d.LAST_NAME+" "+d.FIRST_NAME+" "+d.PATRONYMIC
    }    
  }
}

export default profile